'use strict';
var BASWebServices;
(function (BASWebServices) {
    var ReverseFilter = (function () {
        function ReverseFilter() {
        }
        ReverseFilter.Factory = function () {
            return function (input) {
                return input.slice(0, input.length).reverse();
            };
        };
        return ReverseFilter;
    }());
    BASWebServices.ReverseFilter = ReverseFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ReverseFilter.js.map